import * as XLSX from "xlsx";
import { v4 as uuidv4 } from "uuid";

import { ExcelData } from "./ExcelData";

// Function to convert Excel serial numbers to JavaScript Date
const excelSerialToLocalDate = (serial: number): Date => {
  const excelEpoch = new Date(1899, 11, 30);
  const days = Math.floor(serial);
  const milliseconds = (serial - days) * 24 * 60 * 60 * 1000;
  // Create a date in local time (not UTC)
  const date = new Date(excelEpoch.getTime() + days * 24 * 60 * 60 * 1000 + milliseconds);
  // Remove time part for pure date
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

const excelToUUID = (file: File, onSuccess: (data: { uuid: string; url: string; extractedData: ExcelData }) => void, onError?: (error: Error) => void) => {
  const reader = new FileReader();
  reader.onload = async (e) => {
    try {
      const arrayBuffer = e.target?.result as ArrayBuffer;
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      const sheetName = workbook.SheetNames[2];
      const sheet = workbook.Sheets[sheetName];
      const uuid = uuidv4();

      const normalize = (val?: any) => val?.toString().trim().toLowerCase();

      const isNA = (val?: any) => {
        const v = normalize(val);
        return !v || v === "no" || v === "n/a";
      };

      let dataProduzione: Date | null = null;
      const rawDataProduzione = sheet["C6"]?.v;
      if (typeof rawDataProduzione !== "number" || isNaN(rawDataProduzione) || rawDataProduzione <= 0) {
        window.alert(
          "Attenzione: la data di produzione è mancante o non valida nel file Excel. Verrà mostrata la data 01/01/1970."
        );
        dataProduzione = new Date(0); // 01/01/1970
      } else {
        dataProduzione = excelSerialToLocalDate(rawDataProduzione);
      }

      // ----- Extract data from the sheet (specific cells) -----
      const extractedData: ExcelData = {
        code: uuid.toString(),
        articolo: (sheet["B4"]?.v).toString(),
        lotto: (sheet["B6"]?.v).toString(),
        dataProduzione: dataProduzione,
        quantita: (sheet["D6"]?.v).toString(),
        coa: isNA(sheet["E6"]?.v) ? "N/A" : sheet["E6"].v.toString(),
        numeroOrdine: (sheet["F6"]?.v).toString(),
        numeroDdt: isNA(sheet["G6"]?.v) ? "N/A" : sheet["G6"].v.toString(),
        cliente: (sheet["H6"]?.v).toString(),
        sds: isNA(sheet["I6"]?.v) ? "N/A" : "SDS",
        coaPdfId: null,
        sdsPdfId: null,
        ddtPdfId: null,
      };

      // ----- Set url for the QR code -----
      const url = `https://nanesa.azurewebsites.net/check/qrCode?qrCode=${uuid}`;

      // UUID, URL and extracted data are passed to the onSuccess callback
      onSuccess({ uuid, url, extractedData: extractedData });
    } catch (error) {
      if (onError) {
        onError(error as Error);
      } else {
        console.error("Error processing Excel file:", error);
      }
    }
  };

  reader.readAsArrayBuffer(file);
};

export default excelToUUID;
